import * as React from 'react';
import type { SVGProps } from 'react';
export const SvgReload = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    style={{
      color: 'inherit',
      ...props.style,
    }}
  >
    <path
      d="M14.66 15.66A8 8 0 1 1 17 10h-2a6 6 0 1 0-1.76 4.24zM12 10h8l-4 4z"
      fill="currentColor"
    />
  </svg>
);
